import React, { useEffect, useState } from 'react'
import NavBar from "./NavBar";
import Sidebar from "./Sidebar/Sidebar";
import { useSelector } from "react-redux";
import PlatformSidebar from "./Sidebar/PlatformSidebar";
import { dismissDashboardOpening, isDashboardOpening } from "../helpers/dashboardTransition";

const MainContainer = ({ children }) => {
    const loggedIn = useSelector(state => state.loggedReducer);
    const user = useSelector(state => state.userReducer?.user);
    const shellReady = Boolean(user?.id || user?.email);
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [theme, setTheme] = useState(() => {
        const savedTheme = localStorage.getItem('appTheme');
        return savedTheme === 'dark' || savedTheme === 'light' ? savedTheme : 'light';
    });
    // const excludeSideBar = excludeSideBar || false;
    const expandSidebar = () => {
        setIsSidebarCollapsed(false);
        localStorage.setItem('sidebarCollapsed', false);
    };

    const toggleSidebar = () => {
        setIsSidebarCollapsed(prev => {
            const next = !prev;
            localStorage.setItem('sidebarCollapsed', next);
            return next;
        });
    };
    useEffect(() => {
        const savedSidebarState = localStorage.getItem('sidebarCollapsed');
        if (savedSidebarState !== null) {
            setIsSidebarCollapsed(savedSidebarState === 'true');
        }

        const savedTheme = localStorage.getItem('appTheme');
        if (savedTheme === 'dark' || savedTheme === 'light') {
            setTheme(savedTheme);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('appTheme', theme);

        const cls = theme === 'dark' ? 'theme-dark' : 'theme-light';
        document.body.classList.remove('theme-dark', 'theme-light');
        document.body.classList.add(cls);
    }, [theme]);

    // Keep "Opening dashboard…" until sidebar can render with user data (not on bare mount).
    useEffect(() => {
        if (!isDashboardOpening()) {
            return undefined;
        }
        if (!shellReady) {
            const safety = window.setTimeout(() => dismissDashboardOpening(), 10000);
            return () => window.clearTimeout(safety);
        }

        let cancelled = false;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                if (!cancelled) {
                    dismissDashboardOpening();
                }
            });
        });
        return () => {
            cancelled = true;
        };
    }, [shellReady]);

    return (
        <div className={`dashBoard-container`}>
            <NavBar isLogged={loggedIn} collapsed={isSidebarCollapsed} theme={theme} />
            <div className={`main-container ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                {children}
            </div>
            <PlatformSidebar theme={theme} />
            <Sidebar
                toggleSidebar={toggleSidebar}
                isCollapsed={isSidebarCollapsed}
                expandSidebar={expandSidebar}
                theme={theme}
                setTheme={setTheme}
            />
        </div>
    )
}
export default MainContainer
